import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
const slidesWithDescriptionBlockSchema = Joi.object({
  type: Joi.string().valid('slidesWithDescriptionBlock').required(),
  code: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  background: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  descriptionColor: Joi.string().allow('', null).required(),
  link: linkSchema.allow('', null).required(),
  slides: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    title: Joi.string().allow('', null).required(),
    titleColor: Joi.string().allow('', null).required(),
    link: linkSchema.allow('', null).required(),
    image: mediaUrlSchema.required(),
    blur: mediaUrlSchema.required()
  }).unknown(true))
}).unknown(true);
export default slidesWithDescriptionBlockSchema;